import Component from 'flarum/common/Component';
import ConversationRow from './ConversationRow';
export default class ConversationDirectory extends Component {
  view() {
    const conversations = this.attrs.conversations || [];
    const selected = this.attrs.selected;
    return m("div", {
      className: "ConversationDirectory",
      role: "list"
    }, conversations.map(conversation => m(ConversationRow, {
      key: conversation.id,
      conversation: conversation,
      active: !!(selected && selected.kind === conversation.kind && selected.key === conversation.sourceId)
    })));
  }
}
flarum.reg.add('flatrate-messaging-ui', 'forum/components/ConversationDirectory', ConversationDirectory);